import { createRuntime } from "./create";
var runtime = createRuntime();
export {
  runtime
};
